export default "__VITE_ASSET__CeaPfiFI__"